<mat-dialog-content class="confirmation-dialog-container">
    <h2 *ngIf="data.title; else defaultTitle" class="confirmation-dialog-title">{{data.title}}</h2>
    <mat-dialog-content *ngIf="data.topContent" [innerHTML]="data.topContent"
        class="confirmation-dialog-content"></mat-dialog-content>
    <mat-dialog-content *ngIf="data.bottomContent"
        class="confirmation-dialog-content">{{data.bottomContent}}</mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions class="right confirmation-dialog-actions">
    <button mat-button *ngIf="!data.hideYesButton" [mat-dialog-close]="true"
        [color]="data.okButtonColor">{{data.yesButtonLabel || "Yes"}}</button>
    <button mat-button *ngIf="!data.hideNoButton" mat-dialog-close>{{data.noButtonLabel || "No"}}</button>
    <button mat-button *ngIf="data.showCancelButton" mat-dialog-close>{{data.closeButtonLabel || "Close"}}</button>
</mat-dialog-actions>

<ng-template #defaultTitle>
    <h2>Confirm</h2>
</ng-template>